import { useContext, useState, useTransition } from "react";
import { User, Lock, Mail, Phone, Code2Icon } from "lucide-react";
import MessageServices from "@services/MessageServices";
import EndPointServices from "@services/ApiServices";
import { useNavigate } from "react-router-dom";
import useLoading from "@hooks/useLoading";
import UtilServices from "@services/UtilServices";
import { GlobalContext } from "@context/GlobalContext";

const SignupForm = () => {
  const [state, dispatch] = useContext(GlobalContext);
  const [isPending, startTransition] = useTransition();
  useLoading(isPending);

  const [emailValid, setEmailValid] = useState(false);

  const [formData, setFormData] = useState({
    nome: "",
    senha: "",
    email: "",
    telefone: "",
    codigoemail: "",
  });
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    startTransition(async () => {
      e.preventDefault();

      if (!validarSenha(formData.senha)) {
        MessageServices.ShowWarning(
          "A senha deve ter no mínimo 8 caracteres, uma letra maiúscula e um caractere especial.",
        );
        return;
      }

      if (!validarTelefone(formData.telefone)) {
        MessageServices.ShowWarning("Telefone inválido.");
        return;
      }

      let data = {
        nome: formData.nome,
        senha: formData.senha,
        email: formData.email,
        telefone: formData.telefone,
      };

      var retornoapi = await EndPointServices.Autentica_VerificarEmail(data);
      if (!retornoapi?.Success) {
        MessageServices.ShowWarning(
          "Email já cadastrado. Utilize outro email.",
        );
        return;
      }
      var retornoapi = await EndPointServices.Autentica_EnviarCodigoEmail(data);
      if (retornoapi?.Success) {
        UtilServices.setStorage("codigoemail", retornoapi?.Message);
        setEmailValid(true);
        MessageServices.ShowInfo(
          "Código de verificação enviado para o email informado.",
        );
      }
    });
  };
  const handleCadastrar = async (e: React.FormEvent) => {
    startTransition(async () => {
      e.preventDefault();

      if (!validarCodigoEmail(formData.codigoemail)) {
        MessageServices.ShowWarning("Código de verificação inválido.");
        return;
      }

      let dados = {
        nome: formData.nome,
        senha: formData.senha,
        email: formData.email,
        telefone: formData.telefone,
      };

      let data = {
        json: dados,
      };

      var retornoapi = await EndPointServices.Autentica_CadastrarUsuario(data);
      if (retornoapi?.Success) {
        MessageServices.ShowWarning("Cadastro feito com sucesso!");

        //recupera o token.
        UtilServices.managerToken(retornoapi?.BaseReturn?.Classe);

        //Seta Dados do Usuario
        UtilServices.setStorage(
          "dadosusuario",
          retornoapi?.BaseReturn?.LstClasse[0],
        );

        dispatch({
          type: "SET_USUARIO",
          payload: retornoapi?.BaseReturn?.LstClasse[0],
        });

        navigate("/ConsultaIbscbs");

        return;
      }
    });
  };
  const validarSenha = (senha: string): boolean => {
    const regex =
      /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/;
    return regex.test(senha);
  };
  const validarCodigoEmail = (codigoemail: string): boolean => {
    const codigoArmazenado = UtilServices.getStorage("codigoemail");
    return codigoemail === codigoArmazenado;
  };
  const validarTelefone = (telefone: string): boolean => {
    const somenteNumeros = telefone.replace(/\D/g, "");
    return somenteNumeros.length === 10 || somenteNumeros.length === 11;
  };

  return (
    <>
      {emailValid && (
        <form onSubmit={handleCadastrar} className="space-y-5">
          {/* Codigo de Verificação */}
          <div className="space-y-2">
            <label
              htmlFor="codigoemail"
              className="text-sm font-medium text-foreground/80"
            >
              Codigo de Verificação
            </label>
            <div className="relative">
              <Code2Icon className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
              <input
                type="number"
                id="codigoemail"
                name="codigoemail"
                value={formData.codigoemail}
                onChange={handleChange}
                placeholder="Codigo de verificação"
                className="w-full pl-12 pr-4 py-3.5 bg-secondary-tail border-1 border-border-tail rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary-tail glow-input"
                required
              />
            </div>
          </div>
          {/* Submit Button */}
          <button
            type="submit"
            className="w-full mt-6 py-3 bg-primary-tail text-primary-tail-foreground font-semibold rounded-lg glow-button active:scale-[0.98] transition-transform"
          >
            Validar
          </button>
        </form>
      )}
      {!emailValid && (
        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Nome */}
          <div className="space-y-2">
            <label
              htmlFor="nome"
              className="text-sm font-medium text-foreground/80"
            >
              Nome
            </label>
            <div className="relative">
              <User className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
              <input
                type="text"
                id="nome"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                placeholder="Seu nome completo"
                className="w-full pl-12 pr-4 py-3.5 bg-secondary-tail border-1 border-border-tail rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary-tail glow-input"
                required
              />
            </div>
          </div>

          {/* Login
      <div className="space-y-2">
        <label
          htmlFor="login"
          className="text-sm font-medium text-foreground/80"
        >
          Login
        </label>
        <div className="relative">
          <UserCircle className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
          <input
            type="text"
            id="login"
            name="login"
            value={formData.login}
            onChange={handleChange}
            placeholder="Escolha seu login"
            className="w-full pl-12 pr-4 py-3.5 bg-secondary-tail border-1 border-border-tail rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary-tail glow-input"
            required
          />
        </div>
      </div>
      */}
          {/* Senha */}
          <div className="space-y-2">
            <label
              htmlFor="senha"
              className="text-sm font-medium text-foreground/80"
            >
              Senha
            </label>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
              <input
                type="password"
                id="senha"
                name="senha"
                value={formData.senha}
                onChange={handleChange}
                placeholder="Crie uma senha segura"
                className="w-full pl-12 pr-4 py-3.5 bg-secondary-tail border-1 border-border-tail rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary-tail glow-input"
                required
              />
            </div>
          </div>

          {/* Email */}
          <div className="space-y-2">
            <label
              htmlFor="email"
              className="text-sm font-medium text-foreground/80"
            >
              Email
            </label>
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="seu@email.com"
                className="w-full pl-12 pr-4 py-3.5 bg-secondary-tail border-1 border-border-tail rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary-tail glow-input"
                required
              />
            </div>
          </div>

          {/* Telefone */}
          <div className="space-y-2">
            <label
              htmlFor="telefone"
              className="text-sm font-medium text-foreground/80"
            >
              Telefone
            </label>
            <div className="relative">
              <Phone className="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-muted-foreground" />
              <input
                type="tel"
                id="telefone"
                name="telefone"
                value={formData.telefone}
                onChange={handleChange}
                placeholder="(00) 00000-0000"
                className="w-full pl-12 pr-4 py-3.5 bg-secondary-tail border-1 border-border-tail rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:border-primary-tail glow-input"
                required
              />
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full mt-6 py-3 bg-primary-tail text-primary-tail-foreground font-semibold rounded-lg glow-button active:scale-[0.98] transition-transform"
          >
            Criar minha conta
          </button>

          <p className="text-center text-sm text-muted-foreground mt-4">
            Já tem uma conta?{" "}
            <a
              href="#"
              className="text-primary-tail hover:underline font-medium"
            >
              Entrar
            </a>
          </p>
        </form>
      )}
    </>
  );
};

export default SignupForm;
